import {useContext, useEffect, useRef} from "react";
import PlayerUI from "../components/player/PlayerUI.tsx"
import {useAppDispatch, useAppSelector} from "../stores/store.ts";
import {playerUIActions} from "../components/player/playerUISlice.ts";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import PlayerLayout from "../components/layouts/PlayerLayout.tsx";
import {Player} from "../components/player/Player.tsx";
import {changeVideoAsync, playerActions} from "../components/player/playerSlice.ts";
import {useAuth} from "../hooks/useAuth.tsx";
import {AppMainStateContext} from "../contexts/AppMainStateContext.tsx";
import UtilsHelper from "../helpers/utilsHelper.ts";
import PlayerPageProvider from "../providers/PlayerPageProvider.tsx";
import {NotificationStatus} from "../components/notification/Notification.tsx";
import {useNotification} from "../providers/NotificationProvider.tsx";

export const PlayerPage = () => {

    const _authService = useAuth();
    const _location = useLocation();
    const _notificationService = useNotification();
    const _navigate = useNavigate();

    const {openLoginModal} = useContext(AppMainStateContext);
    const {ch_id} = useParams();
    const initialRun = useRef(true);
    const dispatch = useAppDispatch();
    const channels = useAppSelector((state) => state.playerUI.channels);
    const actualChannelIndex = useAppSelector((state) => state.playerUI.actualChannelIndex);


    useEffect(() => {
        if (!_authService.token && !_authService.isRefreshTokenAvailable) {
            openLoginModal(true);
            _navigate(`/logowanie?redirectTo=${_location.pathname}`);
            setTimeout(() => {
                _notificationService.showNotification("Brak dostępu", "Zaloguj się, aby uzyskać dostęp.", NotificationStatus.failure);
            }, 1000)
            return;
        }

        if (channels.length > 0 && initialRun.current && _authService.token) {
            const index = channels.findIndex(x => x.ch_id === Number(ch_id));
            console.log("index : ", index);
            const channel = channels.find(x => x.ch_id === Number(ch_id));

            if (channel) {
                initialRun.current = false;
                dispatch(playerUIActions.setChannelToChangeIndex(index));
                dispatch(changeVideoAsync({chId: channel.ch_id}));
            } else {
                _navigate("/404", {replace: true});
                dispatch(playerUIActions.setChannelToChangeIndex(0));
                dispatch(playerUIActions.setActualChannelIndex(0));
            }
        }

        // return () => {
        //     console.log("reset");
        //     dispatch(playerActions.reset());
        //     initialRun.current = true;
        // }
    }, [channels, _authService.token, _authService.isRefreshTokenAvailable, ch_id, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(playerActions.reset());
            // initialRun.current = true; // <-- To jest niepotrzebne. Jeśli wrócisz na stronę, komponent zbuduje się na nowo z domyślnym useRef(true).
        }
    }, [dispatch]);

    useEffect(() => {
        console.log(channels);
        if (channels.length > 0 && actualChannelIndex > 0) {
            const channel = channels[actualChannelIndex];
            UtilsHelper.changeWindowDocumentTitleAndHistoryPath(channel?.name, `/kanaly-tv/${channel?.ch_id}/player`);
        }
    }, [actualChannelIndex, channels]);

    return (
        <PlayerLayout>
            <PlayerPageProvider>
                <Player/>
                <PlayerUI/>
            </PlayerPageProvider>
        </PlayerLayout>
    )
}
